var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-card',{staticClass:"account-page__card mt-12",attrs:{"elevation":"2"}},[_c('account-password')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }